import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DatosService } from '../servicios/datos.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  constructor(@Inject(DOCUMENT) private document: Document, public _datosService : DatosService) { }

  ngOnInit() {
  }

  mostrar = 0
  displayMenu = false
  
  mostrarMenu(){
    this.displayMenu = !this.displayMenu
  }

  SocialMedia  = this._datosService.SocialMedia

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (document.body.scrollTop > 10 ||     
    document.documentElement.scrollTop > 10) {
      document.getElementById('menu').classList.add('top-bar');
      document.getElementById('logo-mobile').classList.add('on');
    }
    else {
      document.getElementById('menu').classList.remove('top-bar')
      document.getElementById('logo-mobile').classList.remove('on')
    }
  }

}
